/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SportBallTennisIcon16Solid = forwardRef('SportBallTennisIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1.072 6.994a7.005 7.005 0 0 1 5.922-5.922 6.227 6.227 0 0 1-1.822 4.1 6.227 6.227 0 0 1-4.1 1.822Z" }),
        React.createElement("path", { d: "M6.232 6.232a7.723 7.723 0 0 0 2.266-5.214 7.001 7.001 0 0 1 6.485 6.485 7.723 7.723 0 0 0-5.215 2.265 7.723 7.723 0 0 0-2.266 5.215 7.001 7.001 0 0 1-6.485-6.485 7.723 7.723 0 0 0 5.215-2.266Z" }),
        React.createElement("path", { d: "M14.928 9.006a7.005 7.005 0 0 1-5.922 5.922 6.227 6.227 0 0 1 1.822-4.1 6.227 6.227 0 0 1 4.1-1.822Z" })));
});
